var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyToolkit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCBC00;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,51.7h-4.8l-4.9-12.3c-1.3-3.3-5.1-1.2-7.1-6.1c-1.1-2.4-0.4-5.2,1.3-6.9l1.5,3.7 c0.3,0.7,0.9,0.9,1.6,0.7l2.7-1.1c0.7-0.3,0.9-0.9,0.7-1.6l-1.5-3.6c2.5,0.1,4.8,1.6,5.9,4.1c1.9,4.7-2.1,6.1-0.9,9.3L70.3,51.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.4,36.4 47.6,42.5 44.4,42.6 35.4,51.7 32,51.7 34.2,46.9 41.5,39.7 41.6,36.5 47.9,33.8  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.1,60.8c0-3.9-3.1-6.8-6.8-6.8H19.9h-0.1c-3.6,0-6.7,3.1-6.7,6.8v0.9c0,3.7,3.1,6.8,6.8,6.8h50.4 C77.3,68.5,77.1,60.9,77.1,60.8z M20.7,64.5c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3S22.5,64.5,20.7,64.5z  M69.5,64.5c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3C72.9,63,71.4,64.5,69.5,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,20.3L21.4,50.7c-0.2,0.3-0.2,0.7-0.3,1h8.7l8.9-19.8V18.6C37.3,18,35.7,18.7,35,20.3z M32.6,33.7l-3,6.7 c-0.2,0.4-0.7,0.6-1.1,0.4c-0.4-0.2-0.6-0.7-0.4-1.1l3-6.7c0.2-0.4,0.7-0.6,1.1-0.4C32.6,32.8,32.8,33.3,32.6,33.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyToolkit);
export default __webpack_public_path__ + "static/media/my-toolkit.437625e010cf7abafb5e40fe42fb7e11.svg";
export { ForwardRef as ReactComponent };